export default {
  data: function () {
    return {
      bulletinHeads: [
        {label: '行业', width: 80},
        {label: '公司', width: 80},
        {label: '模块', width: 80},
        {label: '变动因素', width: 80},
        {label: '变动影响程度', width: 180},
        {label: '变动描述', width: 180},
        {label: '详情', width: 250},
        {label: '发布人', width: 80},
        {label: '时间', width: 90}
      ]
    }
  }
}
